import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { I18nProvider } from "./i18n";
import { router } from "./router";
import "./styles/base.css";
import "./styles/components.css";
import "./styles/home.css";
import "./styles/pages.css";
import "./styles/company.css";
import "./styles/logo.css";
import "./styles/admin.css";
import "./styles/responsive.css";

const root = document.getElementById("root");

if (!root) throw new Error("Root element not found");

const app = (
  <StrictMode>
    <I18nProvider>
      <RouterProvider router={router} />
    </I18nProvider>
  </StrictMode>
);

async function start(container: HTMLElement) {
  if (container.hasChildNodes()) {
    await router.load();
    // Our static prerenderer does not emit TanStack Router's bootstrap payload.
    // Preserve the server boundary shape during the initial client hydration.
    router.ssr = { manifest: undefined };
    hydrateRoot(container, app);
    return;
  }

  createRoot(container).render(app);
}

void start(root);
